<div
    class="feature-hint-container"
    [ngClass]="{ 'tooltip-content': isTooltipContent() }">
    <mat-card class="hint-card">
        <mat-card-header>
            <div class="header-content">
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="info-icon"
                    >info</mat-icon
                >
                <h2 class="header-title">
                    {{
                        'ADDONS.FEATURE_HINTS.' + featureType() + '.TITLE'
                            | translate
                    }}
                </h2>
            </div>
        </mat-card-header>

        <mat-card-content>
            <p
                class="description"
                [innerHTML]="
                    'ADDONS.FEATURE_HINTS.' + featureType() + '.SUBTITLE'
                        | translate
                "></p>

            <div class="feature-benefits">
                <h3>
                    {{
                        'ADDONS.FEATURE_HINTS.' +
                            featureType() +
                            '.BENEFITS_TITLE' | translate
                    }}
                </h3>
                <p>
                    {{
                        'ADDONS.FEATURE_HINTS.' + featureType() + '.BENEFITS'
                            | translate
                    }}
                </p>
            </div>

            <div class="cta-section">
                <p class="highlight">
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        class="star-icon"
                        >star</mat-icon
                    >
                    {{
                        'ADDONS.FEATURE_HINTS.' + featureType() + '.BUY_PHRASE'
                            | translate
                    }}
                </p>
            </div>

            <div class="contact-section">
                <p>
                    {{ 'ADDONS.FEATURE_HINTS.CONTACT_US' | translate }}
                </p>
                <p class="contact-info">
                    <mat-icon fontSet="material-symbols-outlined"
                        >email</mat-icon
                    >
                    <a
                        [href]="
                            'mailto:C4L-Addons-Support@t-systems.com' +
                            getEmailTemplate(
                                'ADDONS.FEATURE_HINTS.' +
                                    featureType() +
                                    '.NAME' | translate
                            )
                        "
                        class="email-link"
                        >C4L-Addons-Support&#64;t-systems.com</a
                    >
                </p>
            </div>
        </mat-card-content>
    </mat-card>
</div>
